import { useRef } from 'react';
import { signal } from '../index.js';
export function useSignal(value, opts) {
    const ref = useRef(undefined);
    if (!ref.current) {
        ref.current = signal(value, opts);
    }
    return ref.current;
}
